<cxone-grid [gridOptions]="reportingSetsGridOptions" *ngIf="isLocalizationSectionLoaded">
</cxone-grid>